// extracted by mini-css-extract-plugin
export default {"wrapper":"MessagesList_wrapper__xtNMB","messages":"MessagesList_messages__R14VR"};